import { Macro } from '../types/Macro';
import { Match } from '../types/Match';

export const matchToMacro = (match?: Match): Macro => {
  const { segment, token, operator, value } = match || ({} as Match);
  return { segment, token, operator, value };
};
